import { Navigate, Outlet } from "react-router-dom";

const Protected = () => {
  const data = localStorage.getItem("role");
  return data ? <Navigate to="/StudyList" /> : <Outlet />;
};

export default Protected;
